/**
 * Created by hashinig on 6/30/18.
 */
(function () {
  'use strict';

  /**
   *
   * @ngdoc service
   * @name adminCrewBatchers.service:CrewBatchService
   *
   * @description
   *
   */
  angular
    .module('trainingRoster')
    .service('TrainingRosterService', TrainingRosterService);

  function TrainingRosterService(TrainingRosterFactory, RemoteService) {
    var self = this;


    self.saveTrainingAutomation = function (trainingAutomation,successFn, errorFn) {
      var automationRequest = {'trainingAutomationConfigs':[]};
      var automationList = [];
      var newAutomation =TrainingRosterFactory.getTrainingAutomationSaveRequest();
      if(trainingAutomation.trainingAutomationConfigId){
        newAutomation.trainingAutomationConfigId =trainingAutomation.trainingAutomationConfigId;
        newAutomation.scheduleStatus = trainingAutomation.scheduleStatus;
        newAutomation.processingStatus = trainingAutomation.processingStatus;
        newAutomation.version = trainingAutomation.version;
      }else{
        newAutomation.scheduleStatus = 'Active';
        newAutomation.processingStatus = 'SCHEDULED';
      }
      newAutomation.rosterCycleId = trainingAutomation.cycle.cycleId;
      trainingAutomation.programDetailsObject.forEach(function(prog){
        newAutomation.trainingProgramId.push(prog.trainingProgramId)
      });
      newAutomation.expiryStartDateTime = trainingAutomation.expiryStart;
      newAutomation.expiryEndDateTime = trainingAutomation.expiryEnd;
      trainingAutomation.crewTypeCodesList.forEach(function(crewType){
        newAutomation.crewTypes.push(crewType.crewTypeCode)
      });
      automationList.push(newAutomation);
      automationRequest.trainingAutomationConfigs = automationList;
      RemoteService.saveTrainingAutomationConfig(automationRequest).then(function(response){
    	  if(response.errors!==[]){
        	  errorFn(response.errors[0]);
          }
          successFn(response);
        },
        function(error){
          errorFn(error);
        });
    };

    self.deleteTrainingAutomation = function (selectedProgram, successFn, errorFn) {
      RemoteService.deleteTrainingAutomationConfig({'trainingAutomationConfigId':selectedProgram}).then(
        function(response){
          if(response.errors!==[]){
        	  errorFn(response.errors[0]);
          }
          successFn(response);
        },
        function(error){
          errorFn(error);
        }
      );
    };

    self.searchTrainingAutomationGridData = function (trainingSearchReq, successFn, errorFn){
      var trainingSearchReq = TrainingRosterFactory.populateTrainingSearchRequest(trainingSearchReq);
      RemoteService.searchTrainingAutomationConfig(trainingSearchReq.rosterCycleId).then(
        function (response) {
          var trainingInfo = TrainingRosterFactory.formatTrainingInfoSearchResponse(response.configuarations);
          var summaries = response.summaries;
          successFn(trainingInfo,summaries);
        },
        function (error) {
          errorFn(error);
        }
      );
    }


    self.getNewTraining = function(){
      return TrainingRosterFactory.getNewTraining();
    }


    self.formatGridSelectedRow = function(rowData,masterList){
      return TrainingRosterFactory.formatGridSelectedRow(rowData,masterList);
    }


    self.assignTrainings = function (cycleIdList,successFn, errorFn) {
      var assignRequest = TrainingRosterFactory.populateTrainingAssignmentRequest(cycleIdList);
      RemoteService.assignTrainings(assignRequest).then(
        function (response) {
          if (response.success){
        	 if(response.errors!==[]){
            	errorFn(response.errors[0]);
             }
            successFn((response));
          }
        },
        function (error) {
          errorFn(error);
        }
      );
    };

    self.deleteTrainingDistribution = function (trainingConfigIds,successFn, errorFn) {
        var deleteRequest = TrainingRosterFactory.populateTrainingAssignmentRequest(trainingConfigIds);
        RemoteService.deleteTrainingDistribution(deleteRequest).then(
          function (response) {
            if (response.success){
          	 if(response.errors!==[]){
              	errorFn(response.errors[0]);
               }
              successFn((response));
            }
          },
          function (error) {
            errorFn(error);
          }
        );
      };

    self.getAllTrainingPrograms = function (successFn, errorFn) {
      RemoteService.getAllTrainingPrograms().then(
        function(response){
          successFn(response.trainingProgramList);
        },
        function(error){
          errorFn(error);
        }
      );
    };



  }
})();
